import { formatClock } from '../utils';
import type { ItemTotal } from '../types';
import ItemTotalsPanel from './ItemTotalsPanel';
import PanelCloseButton from './PanelCloseButton';

export type RecentRow = {
  id: string;
  orderNo: number | undefined;
  text: string;
  at: string | undefined;
  groupId: string | undefined;
  /** Set for station rows — enables Undo via recall. */
  undoTaskId?: number;
};

type Props = {
  itemTotals: ItemTotal[];
  rows: RecentRow[];
  showClose: boolean;
  onClose: () => void;
  onUndo: (taskId: number) => void;
  onOpenRow: (groupId: string) => void;
};

/** The station aux panel: item totals on top, the recently-done window (with Undo) below. */
const StationRecentPanel = ({ itemTotals, rows, showClose, onClose, onUndo, onOpenRow }: Props) => (
  <>
    <ItemTotalsPanel itemTotals={itemTotals} showClose={showClose} onClose={onClose} />

    <div className="flex items-center justify-between gap-2 pl-4 pr-2 py-3 flex-none">
      <h3 className="m-0 text-standard font-bold">Recently done</h3>
      {showClose && itemTotals.length === 0 && <PanelCloseButton onClose={onClose} />}
    </div>
    <div className="flex-1 overflow-y-auto px-3 pb-4 flex flex-col gap-2">
      {rows.length === 0 && (
        <div className="text-grey-dark text-small p-3 text-center">
          Nothing yet — completed items will show up here.
        </div>
      )}
      {rows.map((row) => (
        <div
          key={row.id}
          className={`bg-brand-white border border-grey-lightest rounded p-3 flex items-center gap-2 text-small ${
            row.groupId ? 'cursor-pointer' : ''
          }`}
          onClick={row.groupId ? () => onOpenRow(row.groupId as string) : undefined}
        >
          <span className="font-bold text-brand-secondary flex-none">#{row.orderNo}</span>
          <span className="text-brand-black flex-1 truncate">{row.text}</span>
          {row.undoTaskId === undefined ? (
            <span className="flex-none text-extra-small text-grey-dark">{formatClock(row.at)}</span>
          ) : (
            <button
              className="flex-none text-extra-small font-semibold text-brand-primary px-1 py-0.5 rounded hover:bg-purple-lightest"
              onClick={(e) => {
                e.stopPropagation();
                onUndo(row.undoTaskId as number);
              }}
            >
              Undo
            </button>
          )}
        </div>
      ))}
    </div>
  </>
);

export default StationRecentPanel;
